import {TFunction} from "react-i18next";
import {StatementPaymentStatus, StatementType} from "../../../models/accounting/statements";

export const filtersFactory = (t: TFunction<"translation">) => {
    return [
        {
            key: "number",
            label: t("NUMBER"),
            type: "string",
        },
        {
            key: "type",
            label: t("TYPE"),
            type: "select",
            options: Object.values(StatementType).map((item) => ({
                value: item,
                label: t("STATEMENTS.TYPE." + item.toUpperCase())
            })),
        },
        {
            key: "status",
            label: t("STATUS"),
            type: "select",
            options: Object.values(StatementPaymentStatus).map((item) => ({
                value: item,
                label: item.capitalizeFirstLetter()
            })),
        },
        {
            key: "date",
            label: t("DATE"),
            type: "date",
        },
    ];
}